<form [formGroup]="memberForm" (ngSubmit)="onSubmit()">

    <div class="row">
      <!-- Surname -->
      <div class="form-group col-md-6">
        <label for="surname">
          Họ
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Nhập họ của thành viên. Ví dụ: Nguyễn"></i>
        </label>
        <input formControlName="surname" class="form-control" id="field-surname" name="surname" type="text" maxlength="99" placeholder="Nhập họ" />
      </div>
  
      <!-- First Name -->
      <div class="form-group col-md-6">
        <label for="firstname">
          Tên
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Nhập tên của thành viên. Ví dụ: Văn"></i>
        </label>
        <input formControlName="firstname" class="form-control" id="field-firstname" name="firstname" type="text" maxlength="99" placeholder="Nhập tên" />
      </div>
    </div>
  
    <div class="row">
      <!-- Date of Birth -->
      <div class="form-group col-md-6">
        <label for="dob">
          Ngày Sinh
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Nhập ngày sinh của thành viên. Ví dụ: 1990-01-01"></i>
        </label>
        <input formControlName="dob" class="form-control" id="field-dob" name="dob" type="date" />
      </div>
  
      <!-- Age -->
    </div>
  
    <div class="row">
      <!-- Gender -->
      <div class="form-group col-md-6">
        <label for="gender">
          Giới Tính
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Chọn giới tính của thành viên."></i>
        </label>
        <select class="form-control" formControlName="gender" id="field-gender" name="gender">
            <option value="Female">Nữ</option>
            <option value="Male">Nam</option>
            <option value="Other">Khác</option>
            <option value="None specified">Không xác định</option>
        </select>
    </div>
  
      <!-- Street Number -->
      <div class="form-group col-md-6">
        <label for="street_number">
          Số Nhà
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Nhập số nhà. Ví dụ: 123"></i>
        </label>
        <input formControlName="street_number" class="form-control" id="field-street_number" name="street_number" type="text" placeholder="Nhập số nhà" />
      </div>
    </div>
  
    <div class="row">
      <!-- Address -->
      <div class="form-group col-md-6">
        <label for="address">
          Địa Chỉ
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Nhập địa chỉ. Ví dụ: 456 Đường Elm"></i>
        </label>
        <input formControlName="address" class="form-control" id="field-address" name="address" type="text" placeholder="Nhập địa chỉ" />
      </div>
  
      <!-- City -->
      <div class="form-group col-md-6">
        <label for="city">
          Thành Phố
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Nhập thành phố. Ví dụ: Hà Nội"></i>
        </label>
        <input formControlName="city" class="form-control" id="field-city" name="city" type="text" placeholder="Nhập thành phố" />
      </div>
    </div>
  
    <div class="row">
      <!-- State -->
      <div class="form-group col-md-6">
        <label for="state">
          Tỉnh/Thành
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Nhập tỉnh/thành. Ví dụ: TP.HCM"></i>
        </label>
        <input formControlName="state" class="form-control" id="field-state" name="state" type="text" placeholder="Nhập tỉnh/thành" />
      </div>
  
      <!-- ZIP/Postal Code -->
      <div class="form-group col-md-6">
        <label for="zip">
          Mã Bưu Chính
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Nhập mã bưu chính. Ví dụ: 700000"></i>
        </label>
        <input formControlName="zip" class="form-control" id="field-zip" name="zip" type="text" placeholder="Nhập mã bưu chính" />
      </div>
    </div>
  
    <div class="row">
      <!-- Country -->
      <div class="form-group col-md-6">
        <label for="country">
          Country
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Select the country from the dropdown. Example: USA"></i>
        </label>
        <select formControlName="country" class="form-control" id="field-country" name="country">
          <option value="" disabled selected>Select Country</option>
          <option value="USA">USA</option>
          <option value="Canada">Canada</option>
          <option value="United Kingdom">United Kingdom</option>
          <option value="Australia">Australia</option>
          <option value="India">India</option>
          <option value="Germany">Germany</option>
          <option value="France">France</option>
          <option value="Japan">Japan</option>
          <option value="China">China</option>
          <option value="Brazil">Brazil</option>
          <!-- Add more countries as needed -->
        </select>
      </div>
  
      <!-- Primary Phone -->
      <div class="form-group col-md-6">
        <label for="primary_phone">
          Primary Phone
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter the primary phone number. Example: (555) 555-5555"></i>
        </label>
        <input formControlName="primary_phone" class="form-control" id="field-primary_phone" name="primary_phone" type="text" placeholder="Enter primary phone" />
      </div>
    </div>
  
    <div class="row">
      <!-- Secondary Phone -->
      <div class="form-group col-md-6">
        <label for="secondary_phone">
          Secondary Phone
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter the secondary phone number (optional). Example: (555) 555-5556"></i>
        </label>
        <input formControlName="secondary_phone" class="form-control" id="field-secondary_phone" name="secondary_phone" type="text" placeholder="Enter secondary phone" />
      </div>
  
      <!-- Primary Email -->
      <div class="form-group col-md-6">
        <label for="primary_email">
          Primary Email
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter the primary email address. Example: john.doe@example.com"></i>
        </label>
        <input formControlName="primary_email" class="form-control" id="field-primary_email" name="primary_email" type="email" placeholder="Enter primary email" />
      </div>
    </div>
  
    <div class="row">
      <!-- Secondary Email -->
      <div class="form-group col-md-6">
        <label for="secondary_email">
          Secondary Email
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter the secondary email address (optional). Example: jane.smith@example.com"></i>
        </label>
        <input formControlName="secondary_email" class="form-control" id="field-secondary_email" name="secondary_email" type="email" placeholder="Enter secondary email" />
      </div>
  
      <!-- Head of Department -->
      <div class="form-group col-md-6">
        <label for="headOfDepartment">
          Head of Department
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter the name of the head of the department. Example: John Doe"></i>
        </label>
        <input formControlName="headOfDepartment" type="text" class="form-control" id="field-headOfDepartment" name="headOfDepartment" placeholder="e.g., John Doe, Jane Smith" />
      </div>
    </div>
  
    <div class="row">
      <!-- Salutation -->
      <div class="form-group col-md-6">
        <label for="salutation">
          Salutation
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Select a salutation"></i>
        </label>
        <select formControlName="salutation" class="form-control" id="field-salutation" name="salutation">
          <option value="Mr">Mr</option>
          <option value="Mrs">Mrs</option>
          <option value="Ms">Ms</option>
          <option value="Dr">Dr</option>
        </select>
      </div>
  
      <!-- Booking Quota -->
      <div class="form-group col-md-6">
        <label for="bookingQuota">
          Booking Quota
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter the booking quota for the member"></i>
        </label>
        <input formControlName="bookingQuota" class="form-control" id="field-bookingQuota" name="bookingQuota" type="number" placeholder="Enter booking quota" />
      </div>
    </div>
  
    <div class="row">
      <!-- Actions -->
      <div class="form-group col-md-12">
        <button type="submit" class="btn btn-outline-primary">
          <i class="fas fa-save"></i> Save
        </button>
        <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">
          <i class="fas fa-times"></i> Cancel
        </button>
      </div>
    </div>
  
  </form>
